module.exports = __webpack_public_path__ + "05_bob_grey.5e9af840.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_bob_grey.png
// module id = +em7
// module chunks = 0